var _path;
function _extends() { _extends = Object.assign ? Object.assign.bind() : function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; }; return _extends.apply(this, arguments); }
import * as React from "react";
function SvgEdit(_ref, svgRef) {
  let {
    title,
    titleId,
    ...props
  } = _ref;
  return /*#__PURE__*/React.createElement("svg", _extends({
    width: 18,
    height: 18,
    viewBox: "0 0 18 18",
    fill: "none",
    xmlns: "http://www.w3.org/2000/svg",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _path || (_path = /*#__PURE__*/React.createElement("path", {
    fillRule: "evenodd",
    clipRule: "evenodd",
    d: "M14.182 2.50003C14.0089 2.50002 13.8375 2.5341 13.6776 2.60033C13.5177 2.66656 13.3724 2.76364 13.25 2.88603L12.076 4.05903L13.941 5.92303L15.114 4.75003C15.2984 4.5657 15.4239 4.33085 15.4748 4.07518C15.5256 3.8195 15.4995 3.55449 15.3998 3.31364C15.3 3.0728 15.1311 2.86695 14.9143 2.72213C14.6975 2.57731 14.4427 2.50002 14.182 2.50003ZM12.882 6.98403L11.016 5.12003L3.51602 12.62L2.81602 15.184L5.38002 14.484L12.882 6.98403ZM13.105 1.21403C13.708 0.962454 14.3797 0.928235 15.0052 1.11723C15.6306 1.30622 16.171 1.70668 16.5337 2.25009C16.8965 2.7935 17.0592 3.44609 16.994 4.09621C16.9287 4.74632 16.6396 5.35356 16.176 5.81403L6.30002 15.683C6.2077 15.7752 6.09292 15.8418 5.96702 15.876L1.94502 16.976C1.81744 17.0108 1.68293 17.0113 1.55512 16.9774C1.42731 16.9435 1.31074 16.8763 1.21723 16.7828C1.12372 16.6893 1.0566 16.5727 1.02267 16.4449C0.988737 16.3171 0.989203 16.1826 1.02402 16.055L2.12402 12.033C2.15825 11.9071 2.22478 11.7923 2.31702 11.7L12.189 1.82803C12.4496 1.56596 12.7591 1.35767 13.1 1.21503L13.105 1.21403Z",
    fill: "#818386"
  })));
}
const ForwardRef = /*#__PURE__*/React.forwardRef(SvgEdit);
export default __webpack_public_path__ + "static/media/edit.c56cc2c1269ac8bd0fb4b55a0afd8910.svg";
export { ForwardRef as ReactComponent };